import Contact from '@models/Contact';
import { GroupActionSource } from '@app/types';
import analytics from '@support/analytics';

export function copyEmails(
  selectedContacts: Array<Contact>,
  contactIsRestricted: (contact: Contact) => boolean,
  source: GroupActionSource,
) {
  return () => {
    const emails = selectedContacts
      .map((contact) => !contactIsRestricted(contact) && contact.email)
      .filter((email) => !!email);
    if (emails.length > 0) {
      navigator.clipboard.writeText(emails.join(','));
    }
    analytics.track('Email Copied', {
      source,
      contactCount: selectedContacts.length,
      emailCount: emails.length,
    });
  };
}

export function copyPhoneNumbers(
  selectedContacts: Array<Contact>,
  contactIsRestricted: (contact: Contact) => boolean,
  source: GroupActionSource,
) {
  return () => {
    const phoneNumbers = selectedContacts
      .map((contact) => !contactIsRestricted(contact) && contact.phone)
      .filter((phone) => !!phone);
    if (phoneNumbers.length > 0) {
      navigator.clipboard.writeText(phoneNumbers.join('\n'));
    }
    analytics.track('Phone Numbers Copied', {
      source,
      contactCount: selectedContacts.length,
      phoneNumberCount: phoneNumbers.length,
    });
  };
}
